(() => {
  const ROOT_SELECTOR = '.check_time_component';
  const UI_CLASS = 'ddt-ui';

  const TIME_SLOTS = ['08時-12時','14時-16時','16時-18時','18時-20時','19時-21時'];
  const MAX_DAYS = 7;

  const TEST_DISABLE_NOTE = true; // ←テスト中だけtrue（本番はfalse）

  function fmtYYYYMMDD(dt){
    const y = dt.getFullYear();
    const m = String(dt.getMonth()+1).padStart(2,'0');
    const d = String(dt.getDate()).padStart(2,'0');
    return `${y}/${m}/${d}`;
  }
  function addDays(dt, n){ const x=new Date(dt); x.setDate(x.getDate()+n); return x; }

  function parseLooseDate(raw){
    if (!raw) return null;

    // 2026年01月12日
    let m = raw.match(/(\d{4})\D+(\d{1,2})\D+(\d{1,2})/);
    if (m) return new Date(+m[1], +m[2]-1, +m[3]);

    // 2026/01/12
    m = raw.match(/^(\d{4})\/(\d{2})\/(\d{2})$/);
    if (m) return new Date(+m[1], +m[2]-1, +m[3]);

    return null;
  }

  async function updateCartAttributes(attrs){
    await fetch('/cart/update.js', {
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ attributes: attrs })
    });
  }

  async function updateCartNote(noteText){
    await fetch('/cart/update.js', {
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ note: noteText })
    });
  }

  async function fetchCartAttributes(){
    const cart = await fetch('/cart.js').then(r => r.json());
    return cart.attributes || {};
  }

  // 前回の指定が残っていたら消す（誤配送防止）
  async function clearDeliveryIfUnselected({ status }) {
    try {
      const attrs = await fetchCartAttributes();
      const hasDate = (attrs.DeliveryDate || '').trim();
      const hasTime = (attrs.DeliveryTime || '').trim();
      const hasText = (attrs.DeliveryDateTimeText || '').trim();

      if (!hasDate && !hasTime && !hasText) return;

      if (status) status.textContent = '前回の指定をクリア中…';

      await updateCartAttributes({
        DeliveryDate: '',
        DeliveryTime: '',
        DeliveryDateTimeText: '',
        delivery_date: '',
        delivery_time: ''
      });

      // ★特別な指示（カートノート）も空にする
      if (!TEST_DISABLE_NOTE) {
        await updateCartNote('');
      }

      if (status) status.textContent = '未指定（前回の指定をクリアしました）';
    } catch (e) {
      console.warn('[DDT] clearDeliveryIfUnselected failed', e);
    }
  }

  // リロード時：ヤマトinput / カートattributes から郵便番号を復元して表に戻す（必要なら）
  async function syncZipOnLoad({ zipInput, appZip, status }) {
    try {
      const yamatoZip = (appZip?.value || '').trim();

      let cartZip = '';
      try {
        const attrs = await fetchCartAttributes();
        cartZip =
          (attrs.DeliveryZip || '').trim() ||
          (attrs['入力時の郵便番号'] || '').trim() ||
          (attrs['配送先 郵便番号'] || '').trim();
      } catch (e) {}

      const targetZip = yamatoZip || cartZip || (zipInput?.value || '').trim();
      if (!targetZip) return;

      if (zipInput && zipInput.value.trim() !== targetZip) {
        zipInput.value = targetZip;
      }

      // ※ここで自動的に最短日計算まで走らせたい場合は
      // zipInput.dispatchEvent(new Event('input', { bubbles:true })) を追加してもOK
      // ただし「戻る」で無限計算になることがあるので、今は入れていません。
      if (status) status.textContent = '';
    } catch (e) {
      console.warn('[DDT] syncZipOnLoad failed', e);
    }
  }

  function isValidZipLike(v){
    const s = (v || '').trim();
    return /^\d{3}-\d{4}$/.test(s);
  }

  function mount(root){
    if (root.querySelector(`.${UI_CLASS}`)) return true;

    // ヤマトアプリ側の入力＆結果要素
    const appZip   = root.querySelector('#postal_code-input');
    const hidden   = root.querySelector('#hidden-result');
    const shown    = root.querySelector('.estimated_delivery_time');
    const appError = root.querySelector('.error_noti'); // アプリ側エラー表示

    const ui = document.createElement('div');
    ui.className = UI_CLASS;
    ui.innerHTML = `
      <div class="ddt-card">
        <div class="ddt-head">
          <div class="ddt-title">配達希望日時の選択</div>
          <div class="ddt-sub">
            郵便番号は配送住所の郵便番号をご入力ください。<br>
            配達希望日がない場合は入力せずお進みください。
          </div>
        </div>

        <div class="ddt-block">
          <label class="ddt-label">配送先 郵便番号</label>
          <div class="ddt-row">
            <input class="ddt-zip"
              type="text"
              inputmode="numeric"
              placeholder="例）100-0000"
              autocomplete="postal-code"
              maxlength="9">
          </div>
          <div class="ddt-status"></div>
          <div class="ddt-min">
            最短お届け予定日：<span class="ddt-min-date">-</span>
          </div>
        </div>

        <div class="ddt-block">
          <div class="ddt-label">配達希望日（任意）</div>
          <div class="ddt-grid ddt-dates"></div>
          <button type="button" class="ddt-clear ddt-clear-date">希望日を指定しない</button>
        </div>

        <div class="ddt-block">
          <div class="ddt-label">配達希望時間帯（任意）</div>
          <div class="ddt-grid ddt-times"></div>
          <button type="button" class="ddt-clear ddt-clear-time">時間帯を指定しない</button>
        </div>

        <details class="ddt-note">
          <summary>ご注意</summary>
          <div class="ddt-note-body">
            <ul>
              <li>ここで入力した郵便番号と、チェックアウト画面で入力する配送先郵便番号が異なる場合、ご希望の配達日時にお届けできない可能性があります。</li>
              <li>銀行振込をご利用の場合も、入金確認のタイミングによってはご希望の配達日時に添えない場合があります。</li>
              <li>ネコポス対象商品はポスト投函のため、配達日時指定は適用されません。</li>
            </ul>
          </div>
        </details>
      </div>
    `;
    root.appendChild(ui);

    // refs
    const zipInput = ui.querySelector('.ddt-zip');
    const minDate  = ui.querySelector('.ddt-min-date');
    const datesBox = ui.querySelector('.ddt-dates');
    const timesBox = ui.querySelector('.ddt-times');
    const status   = ui.querySelector('.ddt-status');
    const clearDateBtn = ui.querySelector('.ddt-clear-date');
    const clearTimeBtn = ui.querySelector('.ddt-clear-time');

    let selectedDate = '';
    let selectedTime = '';

    // 最短日取得の成功フラグ（アプリ結果で判定）
    let lookupOk = false;
    let lookupTimer = null;

    function markActive(container, btn){
      [...container.querySelectorAll('button.ddt-btn')].forEach(b => b.classList.remove('is-active'));
      if (btn) btn.classList.add('is-active');
    }

    function setPickersEnabled(enabled){
      ui.querySelectorAll('.ddt-btn, .ddt-clear').forEach(el => {
        el.disabled = !enabled;
        el.style.opacity = enabled ? '' : '.45';
        el.style.pointerEvents = enabled ? '' : 'none';
      });
    }

    function applyAppErrorState(){
      const isErrVisible = !!(appError && getComputedStyle(appError).display !== 'none');
      if (isErrVisible) {
        lookupOk = false;
        setPickersEnabled(false);
        minDate.textContent = '-';
        status.textContent = '郵便番号が無効です。配送先の郵便番号（ハイフンあり）をご確認ください。';
      }
    }

    async function save(){
      const zip = (zipInput.value || '').trim();
      const date = selectedDate;
      const time = selectedTime;

      const dateTimeText =
        (date && time) ? `${date} ${time}` :
        (date) ? `${date}` :
        (time) ? `${time}` : '';

      status.textContent = '保存中…';

      await updateCartAttributes({
        DeliveryZip: zip,

        // NE用（最重要）
        delivery_date: date,
        delivery_time: time,

        // 互換・保険
        DeliveryDate: date,
        DeliveryTime: time,
        DeliveryDateTimeText: dateTimeText
      });

      // ノート（備考欄）はテスト中は書かない
      const note =
        dateTimeText
          ? `DeliveryDate=${date || ''}\nDeliveryTime=${time || ''}`.trim()
          : '';

      if (!TEST_DISABLE_NOTE) {
        await updateCartNote(note);
      }

      status.textContent = dateTimeText ? `保存しました：${dateTimeText}` : '指定なし（保存しました）';
    }

    function renderTimes(){
      timesBox.innerHTML = '';
      TIME_SLOTS.forEach(slot => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'ddt-btn';
        b.textContent = slot;
        b.addEventListener('click', async () => {
          if (!lookupOk) {
            status.textContent = '郵便番号入力後、最短日が表示されてから選択してください。';
            return;
          }
          selectedTime = slot;
          markActive(timesBox, b);
          await save();
        });
        timesBox.appendChild(b);
      });
    }

    function renderDates(minDt){
      datesBox.innerHTML = '';
      for (let i=0;i<=MAX_DAYS;i++){
        const d = fmtYYYYMMDD(addDays(minDt, i));
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'ddt-btn';
        b.textContent = d;
        b.addEventListener('click', async () => {
          if (!lookupOk) {
            status.textContent = '郵便番号入力後、最短日が表示されてから選択してください。';
            return;
          }
          selectedDate = d;
          markActive(datesBox, b);
          await save();
        });
        datesBox.appendChild(b);
      }
    }

    // 最短日の監視
    let last = '';
    const tick = () => {
      applyAppErrorState();

      const raw = (hidden?.value?.trim()) || (shown?.textContent?.trim()) || '';
      if (!raw) return;

if (raw === last) {
  if (status.textContent === '最短日を計算中…' || status.textContent === '最短日を更新中…') {
    status.className = 'ddt-status';
    status.textContent = '';
  }
  return;
}

      const dt = parseLooseDate(raw);
      if (!dt || isNaN(dt)) return;

      last = raw;
      lookupOk = true;

      // タイムアウト停止
      if (lookupTimer) {
        clearTimeout(lookupTimer);
        lookupTimer = null;
      }

      minDate.textContent = raw;
      renderDates(dt);
      renderTimes();
      setPickersEnabled(true);

if (status.textContent === '最短日を計算中…' || status.textContent === '最短日を更新中…') {
  status.className = 'ddt-status';
  status.textContent = '';
}
    };

    // 初期は無効化
    setPickersEnabled(false);

    // ===== 郵便番号入力 → 自動整形 → 自動で最短日取得（これ1個だけ） =====
    let zipTimer = null;

    zipInput.addEventListener('input', () => {
      // 数字だけ
      let v = (zipInput.value || '').replace(/[^\d]/g, '');

      // 7桁まで
      if (v.length > 7) v = v.slice(0, 7);

      // 000-0000 に整形
      if (v.length >= 4) v = v.slice(0, 3) + '-' + v.slice(3);

      zipInput.value = v;

      // 状態リセット
      lookupOk = false;
      setPickersEnabled(false);
      last = '';
      minDate.textContent = '-';

      if (zipTimer) clearTimeout(zipTimer);

      // 500ms止まったら最短日取得
      zipTimer = setTimeout(() => {
        if (!isValidZipLike(zipInput.value)) return;

        if (!appZip) {
          status.className = 'ddt-status is-error';
status.textContent = '郵便番号入力欄が見つかりませんでした';
          return;
        }

        // タイムアウト仕込み（帰ってこない/遅い対策）
        if (lookupTimer) clearTimeout(lookupTimer);
        lookupTimer = setTimeout(() => {
          if (!lookupOk) {
            status.className = 'ddt-status is-error';
status.textContent = '最短日を取得できませんでした。郵便番号をご確認のうえ、もう一度お試しください。';
            setPickersEnabled(false);
          }
        }, 6000);

        // 前回と同じでも拾う
        last = '';

        // 裏inputへ反映して計算開始
        appZip.value = zipInput.value;
        appZip.dispatchEvent(new Event('input',  { bubbles:true }));
        appZip.dispatchEvent(new Event('change', { bubbles:true }));
        appZip.dispatchEvent(new Event('blur',   { bubbles:true }));

        status.className = 'ddt-status is-loading';
        status.textContent = '最短日を計算中…';

        // zipを属性に保存（任意）
        updateCartAttributes({ DeliveryZip: zipInput.value.trim() }).catch(()=>{});
      }, 500);
    });

    clearDateBtn.addEventListener('click', async () => {
      selectedDate = '';
      markActive(datesBox, null);
      await save();
    });

    clearTimeBtn.addEventListener('click', async () => {
      selectedTime = '';
      markActive(timesBox, null);
      await save();
    });

    // BFCache対策：戻った時に残表示を掃除
    window.addEventListener('pageshow', () => {
      if (status.textContent === '最短日を計算中…' || status.textContent === '最短日を更新中…') {
        status.textContent = '';
      }
      tick();
    });

    // 初期化：前回指定を消す → 郵便番号だけ復元（必要なら）
    clearDeliveryIfUnselected({ status })
      .then(() => syncZipOnLoad({ zipInput, appZip, status }))
      .then(() => tick())
      .catch(() => tick());

    // すぐ試す＋定期監視
    tick();
    setInterval(tick, 350);

    return true;
  }

  function mountWhenReady(){
    const root = document.querySelector(ROOT_SELECTOR);
    if (!root) return false;
    return mount(root);
  }

  if (mountWhenReady()) return;

  const mo = new MutationObserver(() => {
    if (mountWhenReady()) mo.disconnect();
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  setTimeout(mountWhenReady, 300);
  setTimeout(mountWhenReady, 1200);
  setTimeout(mountWhenReady, 2500);
})();
